import { forwardRef, type SelectHTMLAttributes } from 'react'

import { cn } from '../utilitarios/cn'
import { classesControle } from './campo'

export interface OpcaoSelecao {
  valor: string
  rotulo: string
  desabilitada?: boolean
}

export interface PropriedadesSelecao extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  temErro?: boolean
  opcoes: ReadonlyArray<OpcaoSelecao>
  /** Primeira opção, de valor vazio. Ausente = select sem estado "nada escolhido". */
  vazio?: string
}

export const Selecao = forwardRef<HTMLSelectElement, PropriedadesSelecao>(function Selecao(
  { temErro, opcoes, vazio, className, ...resto },
  ref,
) {
  return (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          classesControle(temErro),
          'h-10 cursor-pointer appearance-none pr-9',
          className,
        )}
        {...resto}
      >
        {vazio !== undefined && <option value="">{vazio}</option>}
        {opcoes.map((opcao) => (
          <option key={opcao.valor} value={opcao.valor} disabled={opcao.desabilitada}>
            {opcao.rotulo}
          </option>
        ))}
      </select>
      <svg
        aria-hidden="true"
        viewBox="0 0 20 20"
        className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-conteudo-fraco"
        fill="currentColor"
      >
        <path d="M5.2 7.4a1 1 0 0 1 1.4 0L10 10.8l3.4-3.4a1 1 0 1 1 1.4 1.4l-4.1 4.1a1 1 0 0 1-1.4 0L5.2 8.8a1 1 0 0 1 0-1.4Z" />
      </svg>
    </div>
  )
})
